import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "../core/i18n";

interface LanguageState {
  currentLanguage: SupportedLanguage;
  setLanguage: (language: SupportedLanguage) => void;
  getCurrentLanguageInfo: () => (typeof SUPPORTED_LANGUAGES)[SupportedLanguage];
}

const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      currentLanguage: "en",
      setLanguage: (language) => set({ currentLanguage: language }),
      getCurrentLanguageInfo: () => {
        const { currentLanguage } = get();
        return SUPPORTED_LANGUAGES[currentLanguage] || SUPPORTED_LANGUAGES.en;
      },
    }),
    {
      name: "language-storage", // unique name for localStorage key
    },
  ),
);

export default useLanguageStore;
